/* Upsell de-dup guard (fix 2026-07-14): the theme re-adds preselected upsells
   (Lifetime Warranty / Insured Shipping) on every Add-to-Cart when the cart
   persists, stacking them 2x/3x at checkout. This guard:
     1) strips an upsell from a /cart/add request if it's ALREADY in the cart,
     2) caps any upsell line to quantity 1 on page load (cleans old carts).
   It is fail-open and only ever REDUCES upsell quantity — never the main product. */
(function () {
  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;

  function upsellVariantIds() {
    var set = {};
    try {
      document.querySelectorAll('cart-drawer-upsell,cart-drawer-gift,product-info-upsell').forEach(function (el) {
        var id = el && el.dataset && el.dataset.id;
        if (id) set[String(id)] = true;
      });
    } catch (e) {}
    return set;
  }

  async function currentCart() {
    var r = await origFetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    return await r.json();
  }

  // (1) Prevent re-adding an upsell already in the cart.
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string' ? input : (input && input.url)) || '';
      if (/\/cart\/add/.test(url) && init && init.body && (init.body instanceof FormData)) {
        var ups = upsellVariantIds();
        if (Object.keys(ups).length) {
          return currentCart().then(function (cart) {
            try {
              var inCart = {}; (cart.items || []).forEach(function (i) { inCart[String(i.id)] = true; });
              var drop = {};
              for (var pair of init.body.entries()) {
                var m = pair[0].match(/^items\[(\d+)\]\[id\]$/);
                if (m && ups[String(pair[1])] && inCart[String(pair[1])]) drop[m[1]] = true;
              }
              if (Object.keys(drop).length) {
                var nf = new FormData();
                for (var p2 of init.body.entries()) {
                  var mm = p2[0].match(/^items\[(\d+)\]\[/);
                  if (mm && drop[mm[1]]) continue;
                  nf.append(p2[0], p2[1]);
                }
                var ni = {}; for (var k in init) ni[k] = init[k]; ni.body = nf; init = ni;
              }
            } catch (e) {}
            return origFetch(input, init).then(function (resp) { setTimeout(capUpsells, 500); return resp; });
          });
        }
      }
    } catch (e) {}
    var pr = origFetch(input, init);
    try {
      var u2 = (typeof input === 'string' ? input : (input && input.url)) || '';
      if (/\/cart\/(add|change|update)/.test(u2)) pr.then(function () { setTimeout(capUpsells, 500); });
    } catch (e) {}
    return pr;
  };

  // (2) Cap any upsell already over quantity 1 (existing/broken carts).
  var capping = false;
  async function capUpsells() {
    if (capping) return;
    try {
      var ups = upsellVariantIds();
      if (!Object.keys(ups).length) return;
      var cart = await currentCart();
      var over = (cart.items || []).filter(function (i) { return ups[String(i.id)] && i.quantity > 1; });
      if (!over.length) return;
      capping = true;
      for (var i = 0; i < over.length; i++) {
        await origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: over[i].key, quantity: 1 })
        });
      }
      capping = false;
      try {
        var dr = document.querySelector('cart-drawer');
        if (dr && typeof dr.renderContents === 'function') {
          var c2 = await currentCart(); dr.renderContents(c2);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (e) {}
    } catch (e) { capping = false; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(capUpsells, 600); });
  else setTimeout(capUpsells, 600);
})();
